<h2 mat-dialog-title>
    {{title}}
</h2>

<mat-dialog-content>
    <div *ngIf="Saving; else notSaving" fxFlexFill fxLayout="column" fxLayoutAlign="center center">
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button *ngIf="!Saving" mat-button color="primary" (click)="close()" telemetry="Submission-SavingDialogOK">
        OK
    </button>
</mat-dialog-actions>

<ng-template #notSaving>
    <div *ngIf="IsError; else noError" style="white-space: pre-wrap;">{{ErrorMessage}}</div>
</ng-template>

<ng-template #noError>
    <div style="white-space: pre-wrap;">{{ValidationMessage}}</div>
</ng-template>